"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = void 0;
// 获取url参数
const getQueryString = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = (window.location.search || '').substr(1).match(reg);
  if (r !== null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};
exports.getQueryString = getQueryString;